import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

/**
 * Load a specific published version of a company configuration.
 * The query is disabled until both `configCode` and `version` are provided.
 */
export function useCompanyConfigVersion(
  configCode: string | undefined,
  version: number | undefined
) {
  return useQuery({
    queryKey: ["companyConfig", configCode, "version", version],
    queryFn: () =>
      api.getCompanyConfigVersion(configCode as string, version as number),
    enabled: Boolean(configCode) && version !== undefined,
  });
}
